export enum Tag {
  VEGETARISCH = "vegetarisch",
  HEALTHY = "healthy",
  SOULFOOD = "soulfood"

}
